"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ErrorMessage_1 = require("../models/ErrorMessage");
const exceptions_1 = require("../exceptions");
exports.default = (response) => __awaiter(this, void 0, void 0, function* () {
    const json = yield response.json();
    const errorMessage = ErrorMessage_1.ErrorMessageFromJSON(json);
    switch (response.status) {
        case 401: {
            return new exceptions_1.AuthenticationError(errorMessage.message);
        }
        case 404: {
            return new exceptions_1.NotFoundError(errorMessage.message);
        }
        case 409: {
            return new exceptions_1.ConflictError(errorMessage.message);
        }
        case 422: {
            return new exceptions_1.InvariantError(errorMessage.message);
        }
        default: {
            return new Error(errorMessage.message);
        }
    }
});
